import React from 'react';
import { Phone, FileText, AlertTriangle, CheckCircle, Ruler, Scale, Clock, Car } from 'lucide-react';
export function OverSizedLoadPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-3358">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-3359">
        <div className="container mx-auto px-4" data-id="element-3360">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-3361">
            Oversize or Overweight Vehicles and Loads
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-3362">
            Special Permit Requirements & Procedures
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-3363">
        <div className="max-w-4xl mx-auto" data-id="element-3364">
          {/* General Procedure */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3365">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-3366">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-3367" />
              General Procedure
            </h2>

            <div className="space-y-6" data-id="element-3368">
              <div className="bg-blue-50 border-l-4 border-blue-500 p-6" data-id="element-3369">
                <p className="text-gray-700" data-id="element-3370">
                  The statutes of the State of Michigan authorize the Department
                  of Transportation to issue special permits for the movement
                  over state highways of vehicles or loads which exceed the size
                  or weight limitations specified by law.
                </p>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-3371">
                <h3 className="font-bold text-gray-900 mb-4" data-id="element-3372">
                  Purpose of the Department:
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-3373">
                  To permit the movement of necessary overweight and oversize
                  vehicles or loads consistent with the following obligations:
                </p>

                <div className="space-y-3" data-id="element-3374">
                  <div className="bg-white rounded-lg p-4 flex items-start" data-id="element-3375">
                    <span className="bg-green-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3376">
                      A
                    </span>
                    <div data-id="element-3377">
                      <p className="font-bold text-gray-900 mb-1" data-id="element-3378">
                        Protection of the Motoring Public
                      </p>
                      <p className="text-gray-700" data-id="element-3379">
                        From potential traffic hazards
                      </p>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg p-4 flex items-start" data-id="element-3380">
                    <span className="bg-green-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3381">
                      B
                    </span>
                    <div data-id="element-3382">
                      <p className="font-bold text-gray-900 mb-1" data-id="element-3383">
                        Protection of Infrastructure
                      </p>
                      <p className="text-gray-700" data-id="element-3384">
                        Highway surfaces, structures, and private property
                      </p>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg p-4 flex items-start" data-id="element-3385">
                    <span className="bg-green-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3386">
                      C
                    </span>
                    <div data-id="element-3387">
                      <p className="font-bold text-gray-900 mb-1" data-id="element-3388">
                        Normal Traffic Flow
                      </p>
                      <p className="text-gray-700" data-id="element-3389">
                        Provisions for normal flow with minimum interference
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Conditions and Limitations */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3390">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-3391">
              Conditions and Limitations
            </h2>

            <div className="space-y-6" data-id="element-3392">
              {/* Section A */}
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-3393">
                <div className="flex items-start mb-3" data-id="element-3394">
                  <span className="bg-blue-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3395">
                    A
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-3396">
                    Permit Eligibility
                  </h3>
                </div>
                <p className="text-gray-700 ml-14" data-id="element-3397">
                  Permits are issued only to business entities or individuals
                  actually doing the transporting. The transporting vehicles to
                  be used must be owned by the applicant or operated under a
                  bona fide lease or rental agreement.
                </p>
              </div>

              {/* Section B */}
              <div className="bg-yellow-50 rounded-lg p-6" data-id="element-3398">
                <div className="flex items-start mb-3" data-id="element-3399">
                  <span className="bg-yellow-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3400">
                    B
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-3401">
                    Load Requirements
                  </h3>
                </div>
                <div className="ml-14 space-y-3 text-gray-700" data-id="element-3402">
                  <p data-id="element-3403">
                    The issuance of permits is limited to those vehicles and/or
                    loads which{' '}
                    <strong data-id="element-3404">
                      cannot reasonably be divided, dismantled, reduced, or
                      otherwise rearranged
                    </strong>{' '}
                    to conform to legal dimensions and/or weights as provided by
                    law.
                  </p>

                  <div className="bg-white rounded-lg p-4" data-id="element-3405">
                    <p className="font-semibold mb-2" data-id="element-3406">Load Arrangement:</p>
                    <ul className="space-y-1 text-sm" data-id="element-3407">
                      <li data-id="element-3408">
                        • Loads shall be arranged to effect the minimum
                        dimensions for height, length, or width
                      </li>
                      <li data-id="element-3409">
                        • <strong data-id="element-3410">Staggered loading is not permitted</strong>
                      </li>
                      <li data-id="element-3411">
                        • If a loaded commodity creates a single over-dimension,
                        two or more commodities may be transported as one load
                        provided:
                        <ul className="ml-4 mt-1" data-id="element-3412">
                          <li data-id="element-3413">- Permit application indicates this</li>
                          <li data-id="element-3414">- Legal axle loadings are not exceeded</li>
                          <li data-id="element-3415">
                            - No additional nonconforming dimensions are created
                            or made greater
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-red-50 border-l-4 border-red-500 p-4" data-id="element-3416">
                    <p className="font-semibold text-red-900 mb-2" data-id="element-3417">
                      Double Bottoms Restriction:
                    </p>
                    <p className="text-sm" data-id="element-3418">
                      Permits will not be issued for the use of double bottoms
                      (truck tractor, semi-trailer and trailer or truck tractor
                      and 2 semi-trailers, or truck and trailer or semi-trailer){' '}
                      <strong data-id="element-3419">
                        except for the movement of loads that are overlength
                        only
                      </strong>
                      .
                    </p>
                  </div>
                </div>
              </div>

              {/* Section C */}
              <div className="bg-purple-50 rounded-lg p-6" data-id="element-3420">
                <div className="flex items-start mb-3" data-id="element-3421">
                  <span className="bg-purple-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3422">
                    C
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-3423">
                    Superloads & Special Consideration
                  </h3>
                </div>
                <div className="ml-14 space-y-3 text-gray-700" data-id="element-3424">
                  <p data-id="element-3425">
                    As a matter of general procedure, permits will not be issued
                    for transportation of loads exceeding limitations specified
                    in "Single Trips" below. Efforts should be made to move
                    vehicles or loads exceeding these limitations by some means
                    other than by highway or to dismantle the object being
                    moved.
                  </p>

                  <div className="bg-white rounded-lg p-4" data-id="element-3426">
                    <p className="font-semibold mb-2" data-id="element-3427">
                      Special Loads Consideration:
                    </p>
                    <p className="text-sm mb-2" data-id="element-3428">
                      Issuance of permits may be considered for limited movement
                      of special loads if:
                    </p>
                    <ul className="space-y-1 text-sm" data-id="element-3429">
                      <li data-id="element-3430">
                        • All efforts to utilize other means of transportation
                        have been exhausted
                      </li>
                      <li data-id="element-3431">
                        • The object being moved cannot feasibly be reduced to
                        comply with specified limitations
                      </li>
                      <li data-id="element-3432">
                        • A complete written explanation is submitted with
                        properly completed application
                      </li>
                    </ul>
                  </div>

                  <div className="bg-red-50 border-2 border-red-500 rounded-lg p-4" data-id="element-3433">
                    <p className="font-bold text-red-900 mb-2" data-id="element-3434">
                      ⚠️ IMPORTANT TIMING REQUIREMENT:
                    </p>
                    <p className="text-sm" data-id="element-3435">
                      It is not possible to give immediate attention to requests
                      for permits in excess of usual limitations (superloads,
                      house moves). Applications and written explanations for
                      special consideration must be on file in the Lansing
                      permit office at least{' '}
                      <strong data-id="element-3436">ten (10) working days prior</strong> to the
                      tentative date of movement.
                    </p>
                  </div>
                </div>
              </div>

              {/* Section D */}
              <div className="bg-gray-50 rounded-lg p-6" data-id="element-3437">
                <div className="flex items-start mb-3" data-id="element-3438">
                  <span className="bg-gray-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3439">
                    D
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-3440">
                    Vehicle Gauge
                  </h3>
                </div>
                <p className="text-gray-700 ml-14" data-id="element-3441">
                  The measurement across the vehicle from outside of tire to
                  outside of tire on the self-propelled equipment or the trailer
                  or semi-trailer or other towed equipment.{' '}
                  <strong data-id="element-3442">
                    This information is required for overweight loads only.
                  </strong>
                </p>
              </div>

              {/* Section E */}
              <div className="bg-red-50 rounded-lg p-6" data-id="element-3443">
                <div className="flex items-start mb-3" data-id="element-3444">
                  <span className="bg-red-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3445">
                    E
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg flex items-center" data-id="element-3446">
                    <Scale className="mr-2" size={20} data-id="element-3447" />
                    Weight Restrictions
                  </h3>
                </div>
                <div className="ml-14 space-y-3 text-gray-700" data-id="element-3448">
                  <p data-id="element-3449">
                    A request for an overweight permit will not be approved for
                    a load consisting of more than one object, and in no event,
                    shall any wheel load exceed{' '}
                    <strong data-id="element-3450">700 pounds per inch of tire width</strong>.
                  </p>

                  <div className="bg-white rounded-lg p-4" data-id="element-3451">
                    <p className="font-semibold mb-2" data-id="element-3452">Exception:</p>
                    <p className="text-sm" data-id="element-3453">
                      Permits will be approved for empty self-propelled earth
                      moving equipment provided it does not exceed{' '}
                      <strong data-id="element-3454">850 pounds per inch of tire width</strong>.
                    </p>
                  </div>

                  <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-3455">
                    <p className="font-bold text-yellow-900 mb-2" data-id="element-3456">
                      Spring Weight Restriction Period:
                    </p>
                    <p className="text-sm" data-id="element-3457">
                      <strong data-id="element-3458">No overweight permits will be issued</strong>{' '}
                      during the spring weight restriction period, except in
                      case of public emergency.
                    </p>
                  </div>
                </div>
              </div>

              {/* Section F */}
              <div className="bg-green-50 rounded-lg p-6" data-id="element-3459">
                <div className="flex items-start mb-3" data-id="element-3460">
                  <span className="bg-green-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3461">
                    F
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg flex items-center" data-id="element-3462">
                    <Ruler className="mr-2" size={20} data-id="element-3463" />
                    Width Restrictions
                  </h3>
                </div>
                <div className="ml-14" data-id="element-3464">
                  <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-3465">
                    <p className="text-gray-700" data-id="element-3466">
                      Permits will not be issued for widths in excess of{' '}
                      <strong data-id="element-3467">14 feet</strong> during the spring weight
                      restriction period, except in a case of public emergency.
                    </p>
                  </div>
                </div>
              </div>

              {/* Section G */}
              <div className="bg-orange-50 rounded-lg p-6" data-id="element-3468">
                <div className="flex items-start mb-3" data-id="element-3469">
                  <span className="bg-orange-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3470">
                    G
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-3471">
                    Height Restrictions
                  </h3>
                </div>
                <div className="ml-14 space-y-3 text-gray-700" data-id="element-3472">
                  <p data-id="element-3473">
                    Careful consideration must be given to any application
                    requesting movement where the overall height exceeds{' '}
                    <strong data-id="element-3474">13 feet 6 inches</strong> because of possible
                    overhead obstructions on proposed routes.
                  </p>

                  <div className="bg-red-50 border-2 border-red-500 rounded-lg p-4" data-id="element-3475">
                    <p className="font-bold text-red-900 mb-2" data-id="element-3476">
                      CERTIFICATION REQUIRED:
                    </p>
                    <p className="text-sm" data-id="element-3477">
                      All applications for permits in excess of 13 feet 6 inches
                      shall certify that the proposed route has been traveled to
                      assure vertical clearance.
                    </p>
                  </div>
                </div>
              </div>

              {/* Section H */}
              <div className="bg-indigo-50 rounded-lg p-6" data-id="element-3478">
                <div className="flex items-start mb-3" data-id="element-3479">
                  <span className="bg-indigo-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3480">
                    H
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg flex items-center" data-id="element-3481">
                    <Car className="mr-2" size={20} data-id="element-3482" />
                    Escort Vehicles
                  </h3>
                </div>
                <div className="ml-14 space-y-3" data-id="element-3483">
                  <div className="bg-white rounded-lg p-4" data-id="element-3484">
                    <p className="font-semibold text-gray-900 mb-3" data-id="element-3485">
                      Requirements:
                    </p>
                    <ul className="space-y-2 text-gray-700 text-sm" data-id="element-3486">
                      <li className="flex items-start" data-id="element-3487">
                        <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-3488" />
                        <span data-id="element-3489">Must be a passenger car or pickup truck</span>
                      </li>
                      <li className="flex items-start" data-id="element-3490">
                        <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-3491" />
                        <span data-id="element-3492">
                          At least one flashing or rotating light on top of the
                          cab
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-3493">
                        <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-3494" />
                        <span data-id="element-3495">
                          <strong data-id="element-3496">Oversize Load sign</strong> displayed on roof:
                          5 feet long × 12 inches high with 8-inch high black
                          letters on yellow background
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-3497">
                        <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-3498" />
                        <span data-id="element-3499">
                          All flashing or rotating amber lights shall be visible
                          for a distance of <strong data-id="element-3500">500 feet</strong>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Section I */}
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-3501">
                <div className="flex items-start mb-3" data-id="element-3502">
                  <span className="bg-blue-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3503">
                    I
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg flex items-center" data-id="element-3504">
                    <Clock className="mr-2" size={20} data-id="element-3505" />
                    Time Restrictions
                  </h3>
                </div>
                <div className="ml-14 space-y-3" data-id="element-3506">
                  <p className="text-gray-700" data-id="element-3507">
                    Permits are issued for{' '}
                    <strong data-id="element-3508">daylight hours only, Monday through Friday</strong>.
                    In some instances, other time limitations may be applied.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Holiday Restrictions */}
          <div className="bg-red-50 border-2 border-red-500 rounded-lg shadow-md p-8 mb-8" data-id="element-3509">
            <h2 className="text-2xl font-bold text-red-900 mb-6 flex items-center" data-id="element-3510">
              <AlertTriangle className="mr-3" size={28} data-id="element-3511" />
              Holiday Movement Restrictions
            </h2>

            <div className="bg-white rounded-lg p-6 mb-4" data-id="element-3512">
              <p className="text-gray-800 font-semibold mb-4" data-id="element-3513">
                Under no condition will a permit be issued for a movement to
                take place from{' '}
                <strong data-id="element-3514">12:00 noon on the day preceding the holiday</strong> and
                continuing until{' '}
                <strong data-id="element-3515">daylight of the first day after</strong> the holidays
                listed below:
              </p>

              <div className="grid md:grid-cols-2 gap-3" data-id="element-3516">
                <div className="bg-red-50 rounded-lg p-3 flex items-center" data-id="element-3517">
                  <span className="text-2xl mr-3" data-id="element-3518">🎄</span>
                  <span className="font-semibold" data-id="element-3519">Christmas Day</span>
                </div>
                <div className="bg-red-50 rounded-lg p-3 flex items-center" data-id="element-3520">
                  <span className="text-2xl mr-3" data-id="element-3521">🦃</span>
                  <span className="font-semibold" data-id="element-3522">Thanksgiving Day</span>
                </div>
                <div className="bg-red-50 rounded-lg p-3 flex items-center" data-id="element-3523">
                  <span className="text-2xl mr-3" data-id="element-3524">🇺🇸</span>
                  <span className="font-semibold" data-id="element-3525">Memorial Day</span>
                </div>
                <div className="bg-red-50 rounded-lg p-3 flex items-center" data-id="element-3526">
                  <span className="text-2xl mr-3" data-id="element-3527">👷</span>
                  <span className="font-semibold" data-id="element-3528">Labor Day</span>
                </div>
                <div className="bg-red-50 rounded-lg p-3 flex items-center" data-id="element-3529">
                  <span className="text-2xl mr-3" data-id="element-3530">🎆</span>
                  <span className="font-semibold" data-id="element-3531">Independence Day</span>
                </div>
              </div>
            </div>
          </div>

          {/* Key Takeaways */}
          <div className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-3532">
            <h2 className="text-3xl font-bold mb-6" data-id="element-3533">Key Takeaways</h2>

            <div className="space-y-3" data-id="element-3534">
              <div className="flex items-start" data-id="element-3535">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3536" />
                <span data-id="element-3537">
                  Permits only for loads that cannot be divided, dismantled, or
                  reduced
                </span>
              </div>
              <div className="flex items-start" data-id="element-3538">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3539" />
                <span data-id="element-3540">
                  Issued to business entities/individuals actually doing the
                  transporting
                </span>
              </div>
              <div className="flex items-start" data-id="element-3541">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3542" />
                <span data-id="element-3543">
                  Staggered loading not permitted; loads arranged for minimum
                  dimensions
                </span>
              </div>
              <div className="flex items-start" data-id="element-3544">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3545" />
                <span data-id="element-3546">
                  Superloads require 10 working days advance notice to Lansing
                  office
                </span>
              </div>
              <div className="flex items-start" data-id="element-3547">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3548" />
                <span data-id="element-3549">
                  Max wheel load: 700 lbs/inch (850 lbs/inch for empty earth
                  moving equipment)
                </span>
              </div>
              <div className="flex items-start" data-id="element-3550">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3551" />
                <span data-id="element-3552">
                  No overweight permits during spring weight restrictions
                  (except emergencies)
                </span>
              </div>
              <div className="flex items-start" data-id="element-3553">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3554" />
                <span data-id="element-3555">Width limit 14 feet during spring restrictions</span>
              </div>
              <div className="flex items-start" data-id="element-3556">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3557" />
                <span data-id="element-3558">
                  Height &gt;13'6": Route must be pre-traveled to verify
                  clearance
                </span>
              </div>
              <div className="flex items-start" data-id="element-3559">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3560" />
                <span data-id="element-3561">
                  Escort vehicles: Oversize Load sign (5'×12") + amber lights
                  visible 500 feet
                </span>
              </div>
              <div className="flex items-start" data-id="element-3562">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3563" />
                <span data-id="element-3564">
                  Daylight hours only, Monday-Friday (other restrictions may
                  apply)
                </span>
              </div>
              <div className="flex items-start" data-id="element-3565">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3566" />
                <span data-id="element-3567">
                  No movement from noon before holiday until daylight after (5
                  major holidays)
                </span>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-3568">
            <h2 className="text-3xl font-bold mb-4" data-id="element-3569">
              Need Help with Oversize/Overweight Permits?
            </h2>
            <p className="text-xl mb-6" data-id="element-3570">
              Expert guidance on special transport permits and compliance
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-3571">
              <Phone className="mr-3" size={24} data-id="element-3572" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-3573">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}